import emiter, { _EVENTS } from '../../../events';
import { _APIS } from 'apis';
import request from 'request';
import { DEFAULT_PAGE_INFO } from '../../../consts';
import {message} from "antd";

export const useCarModelPrice = () => {
	const searchFormReset = (form: any) => {
		emiter.emit(_EVENTS.PRODUCT_PRICE.CAR_MODEL_PRICE.SEARCH, {
			...form.getFieldsValue(),
      ...DEFAULT_PAGE_INFO
		});
	};
	const searchFormFinish = (form: any) => {
		emiter.emit(_EVENTS.PRODUCT_PRICE.CAR_MODEL_PRICE.SEARCH, {
			...form.getFieldsValue(),
      ...DEFAULT_PAGE_INFO
		});
	};

	const onSearchAction = (load: any) => {
		emiter.on(_EVENTS.PRODUCT_PRICE.CAR_MODEL_PRICE.SEARCH, load);
	};

	const search = (params: any) => {
		if (params.status === undefined || params.status === '') {
			params.status = -1
		}
		if (params.veh_num_type === undefined || params.veh_num_type === '') {
			params.veh_num_type = -1
		}
		return request.post(_APIS.PRODUCT_PRICE.CAR_MODEL_PRICE.SEARCH, params);
	};

	const update = (params: any) => request.post(_APIS.PRODUCT_PRICE.CAR_MODEL_PRICE.EDIT, params);

	const getDetail = (params: any) => request.post(_APIS.PRODUCT_PRICE.CAR_MODEL_PRICE.VIEW, params);

	const prodBatchEdit = (params: any) => request.post(_APIS.PRODUCT_PRICE.CAR_MODEL_PRICE.PROD_BATCH_EDIT, params);

	const getSaasApolloConfig = (params: any) => request.get(_APIS.PRODUCT_PRICE.COMMON.CONFIG, { params });

	const queryRuleList = (params: any) => request.get(_APIS.PRODUCT_PRICE.CAR_MODEL_PRICE.RULE_LIST, { params });

	const tablePagination = (data: any) => {
		emiter.emit(_EVENTS.PRODUCT_PRICE.CAR_MODEL_PRICE.SEARCH, data);
	};

	const tableActionEdit = async (data: any) => {
		const res = await getDrawerDetail(data);
		emiter.emit(_EVENTS.PRODUCT_PRICE.CAR_MODEL_PRICE.EDIT, {
			detail: res,
			drawerInfo: {
				disabled: false,
				title: '编辑',
			},
		});
	};

	const tableActionView = async (data: any) => {
		const res = await getDrawerDetail(data);
		emiter.emit(_EVENTS.PRODUCT_PRICE.CAR_MODEL_PRICE.VIEW, {
			detail: res,
			drawerInfo: {
				disabled: true,
				title: '查看',
			},
		});
	};

	const tableActionAdd = (data: any) => {
		emiter.emit(_EVENTS.PRODUCT_PRICE.CAR_MODEL_PRICE.ADD, {
			...data,
			drawerInfo: {
				disabled: false,
				title: '新建',
			},
		});
	};

	const getDrawerDetail = async (data: any) => {
		if (data.price_mod_code) {
			const res = await getDetail({
				price_mod_code: data.price_mod_code,
			});
			return res.data;
		}
	};

	const drawerSubmit = async (data: any, echoData: any) => {
		if (echoData.rule_code) {
			await update({
				...data,
				rule_code: echoData.rule_code,
			});
		}
		searchByData({

		});
	};

	const searchByData = (query: any = {  }) => {
		emiter.emit(_EVENTS.PRODUCT_PRICE.CAR_MODEL_PRICE.SEARCH, query);
	};

	const prodBatchEditFn = async (data: any) => {
		await prodBatchEdit(data);
		message.success('操作成功');
		searchByData();
	};

	return {
		searchFormReset,
		searchFormFinish,
		search,
		update,
		getDetail,
		prodBatchEditFn,
		tablePagination,
		tableActionEdit,
		tableActionView,
		tableActionAdd,
		onSearchAction,
		getDrawerDetail,
		drawerSubmit,
		searchByData,
		getSaasApolloConfig,
		queryRuleList,
	};
};
